import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { isLoggedInAtom } from '@root/entities/auth'
import { Network } from '@root/entities/network'

import { recentSearchesModelByNetwork } from './reatom-recent-searches'
import { addPairToRecentSearchesRequestAction } from './recent-searches-requests'

import type { Pair } from '@root/entities/pair'

export const addPairToRecentSearchesAction = action(
  async (ctx, pair: Pair.PairMinimal) => {
    const isLoggedIn = ctx.get(isLoggedInAtom)
    if (!isLoggedIn) {
      return
    }

    const result = await ctx.schedule(() =>
      addPairToRecentSearchesRequestAction(ctx, {
        network: Network.toDto(pair.base.network),
        pairAddress: pair.address,
        baseTokenAddress: pair.base.address,
        quoteTokenAddress: pair.quote.address,
      }),
    )
    if (Result.isSuccess(result)) {
      recentSearchesModelByNetwork[
        pair.base.network
      ].recentSearchesAtom.refresh(ctx, { strategy: 'success-only' })
    }
  },
  'addPairToRecentSearchesAction',
)

export * from './reatom-delete-recent-search'
export * from './reatom-recent-searches'
export * from './recent-searches-requests'
